"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobTargetProgress = exports.JobTargetProgressTask = exports.JobTargetProgressId = exports.Job = exports.Version = exports.Timezone = exports.JobTask = exports.TaskParamsProperties = exports.TaskParamsOta = exports.TaskType = exports.TargetUpdatePolicy = exports.TargetType = exports.TargetSelectionMode = exports.TargetFilterParams = exports.Summary = exports.ExportJobRecord = exports.ExportJobStatus = exports.Status = exports.ScheduleParams = exports.RetryPolicy = exports.MetaData = exports.Log = exports.ExpectedLog = exports.ExportJobType = exports.AlarmsCsvExportJobTypeValue = exports.ExportJobTypeValue = exports.JobId = exports.Command = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../date");
const entity_1 = require("../entity");
const Json = __importStar(require("../json"));
const semver_1 = require("../semver");
const common_1 = require("./device/class/common");
const Ota = __importStar(require("./device/ota"));
const User = __importStar(require("./user"));
exports.NAMESPACE = 'Culligan.Job';
exports.Command = effect_1.Schema.Literal('load', 'run').annotations({
    identifier: `${exports.NAMESPACE}.Command`,
});
exports.JobId = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.JobId`,
});
exports.ExportJobTypeValue = 'devices_csv_export';
exports.AlarmsCsvExportJobTypeValue = 'alarms_csv_export';
exports.ExportJobType = effect_1.Schema.Literal(exports.ExportJobTypeValue, exports.AlarmsCsvExportJobTypeValue).annotations({
    identifier: `${exports.NAMESPACE}.ExportJobType`,
});
exports.ExpectedLog = effect_1.Schema.Literal('HUB_NOT_CONFIGURED', 'INVALID_MODEL_CODE', 'MESSAGE_ACK_TIMEOUT', 'MESSAGE_NOT_DELIVERED', 'MESSAGE_QUEUED', 'MESSAGE_REJECTED', 'NOT_CONNECTED', 'NOT_FOUND', 'OVER_QUOTA', 'SERVICE_UNAVAILABLE', 'TOO_MANY_REQUESTS', 'UNKNOWN_ERROR').annotations({
    identifier: `${exports.NAMESPACE}.ExpectedLog`,
});
exports.Log = effect_1.Schema.String.annotations({
    identifier: `${exports.NAMESPACE}.Log`,
});
exports.MetaData = effect_1.Schema.Struct({
    model: Ota.Build.fields.model,
    // Recurring-rollout dead-clock. Persisted on the job so it survives V2
    // decode/encode instead of being silently stripped.
    rolloutDeadSince: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    rolloutDeadNotified: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.MetaData`,
});
exports.RetryPolicy = effect_1.Schema.Literal('interval').annotations({
    identifier: `${exports.NAMESPACE}.RetryPolicy`,
});
exports.ScheduleParams = effect_1.Schema.Struct({
    command: exports.Command,
    runAt: date_1.DateFromUtcIsoDateString,
    payload: effect_1.Schema.Struct({
        command: exports.Command,
        jobId: exports.JobId,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ScheduleParams`,
});
const SHARED_EXPORT_LIFECYCLE_STATUS = ['queued', 'running', 'succeeded', 'failed'];
const EXPORT_ONLY_STATUS = ['empty'];
exports.Status = effect_1.Schema.Literal('loading', ...SHARED_EXPORT_LIFECYCLE_STATUS, 'coolDown', 'waiting', 'paused', 'completed', 'canceled', 
// TBC
'temporaryError', 'notFound', 'offline', 'failedError', 'delivered').annotations({
    identifier: `${exports.NAMESPACE}.Status`,
});
exports.ExportJobStatus = effect_1.Schema.Literal(...SHARED_EXPORT_LIFECYCLE_STATUS, ...EXPORT_ONLY_STATUS).annotations({
    identifier: `${exports.NAMESPACE}.ExportJobStatus`,
});
exports.ExportJobRecord = effect_1.Schema.Struct({
    id: exports.JobId,
    type: exports.ExportJobType,
    status: exports.ExportJobStatus,
    userId: User.Id,
    tenantScope: effect_1.Schema.Array(effect_1.Schema.NonEmptyString),
    filterSnapshot: Json.Record,
    createdAt: date_1.DateFromUtcIsoDateString,
    updatedAt: effect_1.Schema.optionalWith(date_1.DateFromUtcIsoDateString, { exact: true }),
    requestedAt: date_1.DateFromUtcIsoDateString,
    startedAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
    completedAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
    rowCount: effect_1.Schema.NullOr(effect_1.Schema.Number),
    filePath: effect_1.Schema.NullOr(effect_1.Schema.String),
    fileName: effect_1.Schema.NullOr(effect_1.Schema.String),
    errorCode: effect_1.Schema.NullOr(effect_1.Schema.String),
    errorDetails: effect_1.Schema.NullOr(effect_1.Schema.String),
    downloadUrl: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    downloadUrlExpiresAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ExportJobRecord`,
    description: 'A CSV export job (devices or alarms) persisted in jobs storage.',
});
exports.Summary = effect_1.Schema.Record({ key: exports.Status, value: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()) }).annotations({
    identifier: `${exports.NAMESPACE}.Summary`,
});
exports.TargetFilterParams = effect_1.Schema.Struct({
    serialNumbers: effect_1.Schema.Array(common_1.Id),
}).annotations({
    identifier: `${exports.NAMESPACE}.TargetFilterParams`,
});
exports.TargetSelectionMode = effect_1.Schema.Literal('filter').annotations({
    identifier: `${exports.NAMESPACE}.TargetSelectionMode`,
});
exports.TargetType = effect_1.Schema.Literal('device').annotations({
    identifier: `${exports.NAMESPACE}.TargetType`,
});
exports.TargetUpdatePolicy = effect_1.Schema.Literal('always', 'firstRun').annotations({
    identifier: `${exports.NAMESPACE}.TargetUpdatePolicy`,
});
exports.TaskType = effect_1.Schema.Literal('deviceInsertDataRecord', 'deviceOtaUploadPackage', 'deviceRegistryPropertiesUpdate', 'deviceRegistryUpdate', 'deviceRemoteSendCommand').annotations({
    identifier: `${exports.NAMESPACE}.TaskType`,
});
exports.TaskParamsOta = effect_1.Schema.Struct({
    buildFile: Ota.Build.fields.buildFile,
    targetVersion: Ota.Build.fields.version,
    minVersion: Ota.Build.fields.minVersion,
    previousVersion: effect_1.Schema.optionalWith(semver_1.SemVer, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.TaskParamsOta`,
});
exports.TaskParamsProperties = effect_1.Schema.Struct({
    properties: Json.Record,
}).annotations({
    identifier: `${exports.NAMESPACE}.TaskParamsProperties`,
});
exports.JobTask = effect_1.Schema.Struct({
    type: exports.TaskType,
    params: effect_1.Schema.Union(exports.TaskParamsOta, exports.TaskParamsProperties),
}).annotations({
    identifier: `${exports.NAMESPACE}.JobTask`,
});
exports.Timezone = effect_1.Schema.Literal('Etc/UTC').annotations({
    identifier: `${exports.NAMESPACE}.Timezone`,
});
exports.Version = effect_1.Schema.Literal(1).annotations({
    identifier: `${exports.NAMESPACE}.Version`,
});
exports.Job = effect_1.Schema.Struct({
    ...entity_1.BaseTimestampedEntity.fields,
    id: exports.JobId,
    userId: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(User.Id)).annotations({
        description: 'The user that created the job',
    }),
    name: effect_1.Schema.NonEmptyString,
    targetType: exports.TargetType,
    attempts: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    version: exports.Version,
    enabled: effect_1.Schema.Boolean,
    tasks: effect_1.Schema.Array(exports.JobTask),
    targetSelectionMode: exports.TargetSelectionMode,
    status: exports.Status,
    summary: effect_1.Schema.partialWith(exports.Summary, { exact: true }),
    endedAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
    scheduleId: effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString),
    scheduleParams: effect_1.Schema.NullOr(exports.ScheduleParams),
    metaData: effect_1.Schema.partialWith(exports.MetaData, { exact: true }),
    usesTasks: effect_1.Schema.Array(exports.TaskType),
    retryPolicy: effect_1.Schema.NullOr(exports.RetryPolicy),
    retryInterval: effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.positive(), effect_1.Schema.greaterThanOrEqualTo(600))),
    maxAttempts: effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative())),
    maxTargetsPerIteration: effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.positive())),
    targetFilterParams: effect_1.Schema.NullOr(exports.TargetFilterParams),
    targetUpdatePolicy: effect_1.Schema.NullOr(exports.TargetUpdatePolicy),
    lastAttemptAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
    startAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
    stopAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
    runWeekDays: effect_1.Schema.Null, // Placeholder, not implemented yet
    runDayStartTime: effect_1.Schema.Null, // Placeholder, not implemented yet
    runDayEndTime: effect_1.Schema.Null, // Placeholder, not implemented yet
    timezone: exports.Timezone, // Placeholder, not implemented yet
    notificationTriggers: effect_1.Schema.Array(effect_1.Schema.Literal('completed', 'failed')),
    // Timeout detection fields
    runningInstanceId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    lockExpiry: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString), { exact: true }),
    lastHeartbeat: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString), { exact: true }),
    timeoutCount: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative())), { exact: true }),
    // When true, a filter-based Job may enumerate more targets than the sanity
    // limit; otherwise an over-sized filter fails loud (see job target service).
    allowLargeRollout: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Job`,
    description: 'An asynchronous job.',
});
exports.JobTargetProgressId = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.JobTargetProgressId`,
});
exports.JobTargetProgressTask = effect_1.Schema.extend(exports.JobTask, effect_1.Schema.Struct({
    status: exports.Job.fields.status,
    log: effect_1.Schema.NullOr(exports.Log),
})).annotations({
    identifier: `${exports.NAMESPACE}.JobTargetProgressTask`,
});
exports.JobTargetProgress = effect_1.Schema.Struct({
    ...entity_1.BaseTimestampedEntity.fields,
    id: exports.JobTargetProgressId,
    jobId: exports.Job.fields.id,
    targetType: exports.Job.fields.targetType,
    targetId: common_1.Id,
    status: exports.Job.fields.status,
    attempts: exports.Job.fields.attempts,
    tasks: effect_1.Schema.Array(exports.JobTargetProgressTask),
    lastAttemptAt: exports.Job.fields.lastAttemptAt,
    completedAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
}).annotations({
    identifier: `${exports.NAMESPACE}.JobTargetProgress`,
    description: 'A job progress on a single target.',
});
//# sourceMappingURL=job.js.map